var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 6.667L12.5 10.001H15c0 2.758-2.242 5-5 5a4.892 4.892 0 01-2.333-.584L6.45 15.634A6.609 6.609 0 0010 16.667a6.665 6.665 0 006.667-6.666h2.5l-3.334-3.334zM5 10.001c0-2.759 2.242-5 5-5 .842 0 1.642.208 2.333.583l1.217-1.217A6.609 6.609 0 0010 3.334a6.665 6.665 0 00-6.667 6.667h-2.5l3.334 3.333L7.5 10.001H5z",
    fill: "#fff"
  })));
}
export default SvgRefresh;